import curryRight from 'lodash/curryRight'
import filter from 'lodash/filter'
import flow from 'lodash/flow'
import has from 'lodash/has'
import keyBy from 'lodash/keyBy'
import map from 'lodash/map'
import { createSelector } from 'reselect'

export const getMembers = state => state.static_data.company.members
const getCurrentUser = state => state.static_data.current_user
const getHiringTeam = state => state.static_data.current_user.current_hiring_team_id

const curriedMap = curryRight(map)
const curriedFilter = curryRight(filter)

const indexByHiringTeam = member => ({
  ...member,
  hiring_teams: keyBy(member.hiring_teams, 'id'),
})

const ownedByHiringTeam = hiring_team_id => member => has(member.hiring_teams, hiring_team_id)

const transformMember = memberId => member => ({
  ...member,
  selected: false,
  ...(member.id === memberId && {
    name: `${member.name} (you)`,
    selected: true,
  }),
})

export const getMember = state => state.static_data.current_user.member_id

export const companyMembers = createSelector([getHiringTeam, getCurrentUser, getMembers], (hiring_team_id, user, members) =>
  flow(
    curriedMap(indexByHiringTeam),
    curriedFilter(ownedByHiringTeam(hiring_team_id)),
    curriedMap(transformMember(user.member_id)),
  )(members),
)

export const selectedHiringTeam = createSelector([getCurrentUser], currentUser => currentUser.current_hiring_team_id)
